import flatten from './flatten'
import indexOf from './indexOf'
import sameElements from './sameElements'
import sort from './sort'
import uniqueElements from './uniqueElements'
import xor from './xor'

export { flatten, indexOf, sameElements, sort, uniqueElements, xor }
